import { ElementType, ReactNode } from 'react';

export enum Layer {
	Landowners = 'landowners',
	Devices = 'devices',
	Plants = 'plants',
	Ttms = 'ttms',
	EiaTransmission = 'Electric_Power_Transmission_L-88ejq1',
	EiaSubstations = 'Electric_Substations_11-75dx5w',
	PlannedPlants = 'planned-plants',
	Loads = 'loads'
}

export type LayerUIConfig = {
	id: Layer;
	name: string;
	visible: boolean;
	Icon: ElementType;
	description: string;
	stops?: Stops[];
};

export interface FeatureResult {
	id: string | number;
	name: string;
	latitude: number;
	longitude: number;
	layerType: Layer;
	properties: Record<string, string>;
}

export type GroupedResults = {
	[k in Layer]?: FeatureResult[];
};

export interface AbstractProperties {
	id: number;

	[key: string]: unknown;
}

export interface LandownerProperties extends AbstractProperties {
	name?: string;
	firstName?: string;
	lastName?: string;
	status?: string;
}

export interface DeviceProperties extends AbstractProperties {
	siteId?: string | number;
	site?: string;
	name?: string;
	landowner?: string;
}

export interface PlantProperties extends AbstractProperties {
	name?: string;
}

export interface PlannedPlantProperties extends AbstractProperties {
	name?: string;
	primaryFuel?: string;
	mwNameplate?: number;
}

export interface TTMSProperties extends AbstractProperties {
	name?: string;
	ttmsZone?: string;
}

export interface EiaTransmissionProperties extends AbstractProperties {
	ID?: string;
	TYPE?: string;
	STATUS?: string;
	OWNER?: string;
	VOLT_CLASS?: string;
	SUB_1?: string;
	SUB_2?: string;
}

export interface EiaSubstationsProperties extends AbstractProperties {
	ID?: string;
	NAME?: string;
	TYPE?: string;
	STATUS?: string;
	LINES?: string;
	MIN_VOLT?: string;
	MAX_VOLT?: string;
}

export interface LoadProperties extends AbstractProperties {
	name?: string;
	facilityCategory?: string;
	powerCapacityMw?: number;
}

export type MapStyle = 'light' | 'dark' | 'satellite' | 'standard';

export interface MapStyleOption {
	id: MapStyle;
	name: string;
	url: string;
	icon: ReactNode;
}

export interface Stops {
	label: string;
	color: string;
	min: number;
	max: number;
}

export interface UrlParamsConfig {
	key: string;
	resultKey: string;
	type: 'number' | 'string';
	min?: number;
	max?: number;
	options?: (string | number)[];
	required: boolean;
}

export interface UrlParams {
	longitude?: number;
	latitude?: number;
	zoom?: number;
	deviceId?: string;
}

export interface LayerSearchConfig {
	sourceId: string;
	sourceLayer: string;
	getName: (properties: AbstractProperties) => string;
	getId: (properties: AbstractProperties) => number;
	getSearchableFields: (properties: AbstractProperties) => string[];
}
